import React from "react";
import GraduationCap from "../../../assets/images/fi-rr-graduation-cap.svg";
import PdfFileImage from "../../../assets/images/pdfFile.png";
import { DATE_FORMAT3 } from "../../../constants/stringConstants";
import { DateFormatter, openImageInBrowser } from "../../../functions/commons";
import { Image } from "antd";
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import { isEmpty, isNil } from "lodash";

function EducationDiv({degree,onEdit}) {
 
  return (
    <>
    
      <div className="c1-education-div__logo-text-img" >
        <img src={GraduationCap} alt="graduation-cap" /> 

        <div className="c1ed-logo-text-img__text-img">

<div style={{display:'flex'}}>
          {degree.institute&&<h3>{degree.nameOfDegree}</h3>
          }
            <div onClick={()=>onEdit(degree)} className="edit_icon" style={{marginLeft:'40px'}}><ModeEditOutlineOutlinedIcon style={{height:'20px',width:'20px'}}/> </div>

          </div> 
       {degree.institute&&   <h4>{degree.institute}</h4>
       }
    <p>
            {`${DateFormatter(degree.from,DATE_FORMAT3)} - ${DateFormatter(degree.to,DATE_FORMAT3)}`}
          </p>
          {/* {degree&&
          <div className="c1edlti-text-img__img-div-container">
          {degree?.degreeImage&&
            <EducationalDocs degreeImage={degree.degreeImage} />
            // <Skeleton height={61}  width={79}/>
          }
          </div>
           } */}
           
           {!isNil(degree.degreeImage)&&!isEmpty(degree.degreeImage) && <Image src={PdfFileImage} style={{height:'70px',width:'70px'}}  preview={false} onClick={()=>openImageInBrowser(degree.degreeImage)}/>}

        </div>

      </div>

    </>
  );
}

export default EducationDiv;
